export const stringSorter = (a: string, b: string) => a.localeCompare(b);

export const numberSorter = (a: number, b: number) => a - b;

export const dateSorter = (a: string | Date | number, b: string | Date | number) =>
  new Date(a).getTime() - new Date(b).getTime();
